import { Container, SimpleGrid, Button, Box } from '@chakra-ui/react';

const DashboardPage = () => {

  return (
    <Container maxW="container.xl" py={8}>
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={8} alignItems="center" justifyItems="center">
        <Button
          onClick={() => {
            window.location.href = "/commesse";
          }}
          height="120px"
          width="120px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          boxShadow="md"
        >
          <span role="img" aria-label="commesse" style={{ fontSize: "24px" }}>
            📋
          </span>
          <span>Commesse</span>
        </Button>

        <Button
          height="120px"
          width="120px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          boxShadow="md"
          isDisabled
        >
          <span role="img" aria-label="preventivi" style={{ fontSize: "24px" }}>
            📝
          </span>
          <span>Preventivi</span>
          <Box mt={2}>
            <span style={{ color: "#718096", fontSize: "0.95em" }}>
              Disponibile a breve!
            </span>
          </Box>
        </Button>
        <Button
          onClick={() => {
            window.location.href = "/dipendenti";
          }}
          height="120px"
          width="120px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          boxShadow="md"
        >
          <span role="img" aria-label="gestione personale" style={{ fontSize: "24px" }}>
            👥
          </span>
          Personale
        </Button>


        <Button
          height="120px"
          width="120px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          boxShadow="md"
          isDisabled
        >
          <span role="img" aria-label="qualità" style={{ fontSize: "24px" }}>
            ✅
          </span>
          <span>Qualità</span>
          <Box mt={2}>
            <span style={{ color: "#718096", fontSize: "0.95em" }}>
              Disponibile a breve!
            </span>
          </Box>
        </Button>

        <Button
          height="120px"
          width="120px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          boxShadow="md"
          isDisabled
        >
          <span role="img" aria-label="contabilità" style={{ fontSize: "24px" }}>
            💰
          </span>
          Contabilità
          <Box mt={2}>
            <span style={{ color: "#718096", fontSize: "0.95em" }}>
              Disponibile a breve!
            </span>
          </Box>
        </Button>
      </SimpleGrid>
    </Container>
  );
};

export default DashboardPage;